import mccCodes from '../data/mcc_codes.json';

interface MccCode {
  mcc: string;
  edited_description: string;
  combined_description: string;
  usda_description: string;
  irs_description: string;
  irs_reportable: string;
  id: number;
}

const mccMap = new Map<string, MccCode>(
  (mccCodes as MccCode[]).map((code) => [code.mcc, code])
);

export const getMccName = (mccCode: string): string => {
  if (!mccCode) {
    return 'Unknown MCC';
  }

  const entry = mccMap.get(mccCode);
  if (entry) {
    return entry.combined_description;
  }

  return `MCC ${mccCode}`;
};

export const getMccEntry = (mccCode: string): MccCode | undefined => {
  return mccMap.get(mccCode);
};
